<template>
  <div class="warp" @scroll="handleScroll">
    <div class="header" id="second-banner" v-if="details && details.head">
      <img v-if="details.head.bgImg" :src="details.head.bgImg" alt="">
      <div class="header-content">
        <div class="title" :style="{color: details.head && details.head.title && details.head.title.color, fontSize: details.head && details.head.title && details.head.title.font}">{{ details.head && details.head.title && details.head.title.content }}</div>
        <div class="sub-title" :style="{color: details.head && details.head.titleEnglish && details.head.titleEnglish.color, fontSize: details.head && details.head.titleEnglish && details.head.titleEnglish.font}">{{ details.head && details.head.titleEnglish && details.head.titleEnglish.content }}</div>
        <div class="sub-tips" :style="{color: details.head && details.head.middleText && details.head.middleText.color, fontSize: details.head && details.head.middleText && details.head.middleText.font}" >{{ details.head && details.head.middleText && details.head.middleText.content }}</div>
        <div class="tag-list">
          <div class="tag-li" :style="{color: details.head && details.head.bottomText && details.head.bottomText.color, fontSize: details.head && details.head.bottomText && details.head.bottomText.font}" v-for="tag in details.head && details.head.bottomText && details.head.bottomText.content" :key="tag">
            {{ tag }}
            <div class="tag-bg"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="['tab', {'tab-fixed': tabFixedStatus}]">
      <div class="tab-list" id="second-tab">
        <div :class="['tab-li',{'second-tab': tabIndex == activedTab-1} ,{'actived-tab': tabIndex == activedTab}]" @click="changeTab(tabIndex, tab.type)" v-for="(tab, tabIndex) in details.tab" :key="tabIndex">
          <div class="top-bar" v-if="tabIndex == activedTab"></div>
          <div class="li-name">{{ tab.name }}</div>
          <img v-if="tabIndex == activedTab" src="@/assets/tab-bar.png" alt="">
        </div>
      </div>
    </div>
    <template v-if="details.tab && details.tab[activedTab].type != 'multiTab'">
      <div v-for="(tab, tabIndex) in details.tab" :key="tabIndex" :id="'tab-'+tabIndex">
        <TabContent :tab="tab"></TabContent>
      </div>
    </template>
    <div v-else-if="details.tab" v-for="(subTab, subTabIndex) in details.tab[activedTab].subList" :key="subTabIndex">
      <TabContent :tab="subTab"></TabContent>
    </div>
  </div>
</template>

<script>
import Swiper from "../components/Swiper.vue"
import TabContent from '../components/TabContent.vue'
import axios from 'axios'
import CryptoJS from 'crypto-js'
export default {
    data(){
        return{
          details:{},
          activedTab: 0,
          tabFixedStatus: false
        }
    },
    components: {Swiper, TabContent},
    mounted() {
      let that = this
      window.addEventListener('scroll',function(e){
        that.handleScroll(e)
      })
      this.$emitter.on('changeHeaderRouter', (payload) => {
        if(payload.jsonPath) {
          that.getDetails(payload.jsonPath)
        }
      });
      if(localStorage.getItem('currentPath')) {
        let current = JSON.parse(localStorage.getItem('currentPath'))
        this.getDetails(current.jsonPath)
      }
    },
    methods: {
      changeTab(index, type) {
        this.activedTab = index
        this.$nextTick(()=>{
          let headerHeight = document.getElementById('header-bar').offsetHeight
          let tabHeight = document.getElementById('second-tab').offsetHeight
          let top = type == 'multiTab' ? 0 : document.getElementById(`tab-${index}`).offsetTop - headerHeight - tabHeight
          scrollTo({ top })
        })
      },
      handleScroll(e) {
        this.$nextTick(()=>{
          // let headerHeight = document.getElementById('header-bar').offsetHeight
          // let bannerHeight = document.getElementById('second-banner').offsetHeight
          // this.tabFixedStatus = e.srcElement?.scrollingElement?.scrollTop >= bannerHeight
        })
      },
      async getDetails(url) {
        let that = this
        // console.log(url,"url--")
        // url = 'https://devcdn.ybaobx.com/shunt/config/8621101296498307072.json'
        axios({
            method: 'get',
            url: `${url}?v=${new Date().getTime()}`,
            headers: {
                'sign': CryptoJS.MD5('borun'+new Date().getTime()).toString(),
                'Content-Type': 'application/json'
            }
        })
        .then(function (response) {
            that.details = response.data
            that.activedTab = 0
        })
        .catch(function (error) {
            
        });
      }
    }
}
</script>

<style>
.van-step--vertical:not(:last-child):after {
  border-bottom-width: 0!important;
}
</style>
<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 40Px;
  .header {
    height: 280Px;
    position: relative;
    padding-top: 62Px;
    overflow: hidden;
    img {
      width: 100%;
      height: 280Px;
      position: absolute;
      left: 0;
      // top: 0;
      z-index: -1;
      object-fit: cover;
      object-position: center;
    }
    height: 280Px;
    .header-content {
      width: 1180Px;
      margin: 52Px auto 0;
    }
    .title {
      font-size: 32Px;
      font-weight: 700;
      line-height: 32Px;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 24Px;
    }
    .sub-title {
      font-size: 14Px;
      font-weight: 400;
      line-height: 16Px;
      color: #fff;
      margin-bottom: 36Px;
    }
    .sub-tips {
      font-size: 14Px;
      font-weight: 400;
      line-height: 14Px;
      color: #fff;
      margin-bottom: 30Px;
    }
    .tag-list {
      display: flex;
      .tag-li {
        position: relative;
        font-size: 14Px;
        font-weight: 500;
        letter-spacing: 0Px;
        line-height: 14Px;
        color: rgba(255, 255, 255, 1);
        padding: 8Px 36Px 16Px 28Px;
        border-radius: 4Px;
        background: rgba(176, 152, 80, 1);
        backdrop-filter: blur(4Px);
        margin-right: 30Px;
      }
      .tag-bg {
        position: absolute;
        top: -6px;
        left: -6px;
        width: 100%;
        height: 100%;
        border-radius: 4Px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow:inset 0Px -1Px 3Px  rgba(255, 255, 255, 0.5);
      }
    }
  }
  .tab {
    background: rgba(242, 242, 242, 1);
    .tab-list {
      position: relative;
      // z-index: 20;
      width: 1180Px;
      display: flex;
      align-items: center;
      height: 60Px;
      margin: 0 auto;
      .tab-li {
        display: flex;
        align-items: center;
        height: 60Px;
        cursor: pointer;
        &:last-child .li-name{
          border: none;
        }
      }
      .li-name {
        white-space: nowrap;
        font-size: 18Px;
        font-weight: 400;
        line-height: 18Px;
        color: rgba(153, 153, 153, 1);
        padding: 0 16Px;
        border-right: 1Px solid rgba(151, 151, 151, 1);
      }
      .actived-tab {
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
        .li-name {
          color: rgba(170, 147, 77, 1);
          border: none;
        }
        img {
          width: 38Px;
        }
      }
      .top-bar {
        height: 3Px;
      }
      .second-tab{
        .li-name {
          border: none;
        }
      }
    }
  }
  .tab-fixed {
    width: 100%;
    position: fixed;
    top: 62Px;
    left: 0;
    z-index: 20;
  }
  .content {
    width: 1044Px;
    margin: 0 auto;
    .content-text {
      font-size: 18Px;
      font-weight: 400;
      line-height: 40Px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .common-title {
    font-size: 32Px;
    font-weight: 400;
    line-height: 46Px;
    color: rgba(51, 51, 51, 1);
    margin: 50Px 0 30Px;
    text-align: center;
  }
  .processing {
    margin-top: 88Px;
  }
  .processing-con {
  }
  .processing-li {
    margin-top: 48Px;
    display: flex;
    justify-content: center;
  }
  .processing-right {
    width: 572Px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 24Px;
  }
  .processing-right .processing-content {
    margin-bottom: 24Px;
    height: 274Px;
  }
  .processing-right .processing-content:nth-child(1) {
    margin-right: 24Px;
  }
  .processing-row {
    display: flex;
  }
  .processing-icon {
    width: 78Px;
    height: 78Px;
  }
  .processing-content {
    position: relative;
  }
  .processing-one {
    width: 574Px;
  }
  .processing-intr {
    bottom: 19Px;
    padding: 0 24Px;
  }
  .processing-title {
    font-size: 24Px;
    color: #333333;
    line-height: 31Px;
  }
  .processing-tips {
    width: 224Px;
    font-size: 12Px;
    color: #777777;
    line-height: 16Px;
    padding-top: 10Px;
  }
  .processing-list {
    font-size: 14Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 19Px;
    margin: 12Px 0 0;
  }
  .cover-li {
    width: 100%;
    .left-coverImg {
      width: 50%;
      height: auto;
    }
    .cover-tips {
      font-size: 18Px;
      font-weight: 400;
      line-height: 40Px;
      color: rgba(102, 102, 102, 1);
    }
    .right-coverImg {
      width: 50%;
      height: auto;
    }
  }
  .services {
    margin-top: 39Px;
    display: flex;
    justify-content: center;
  }
  .services-pc {
    display: flex;
  }
  .services-h5 {
    display: none;
  }
  .swiper-h5 {
    position: relative;
    padding: 0 80Px;
    width: calc(100% - 160Px);
    height: unset;
    display: none;
  }
  .about-services-li {
    margin: 0 12Px;
    position: relative;
  }
  .about-services-content {
    position: absolute;
    top: 29Px;
    left: 22Px;
    right: 22Px;
  }
  .about-services-title{
    font-size: 16Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 21Px;
  }
  .about-services-tips {
    padding: 5Px 0 8Px;
    font-size: 12Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 16Px;
  }
  .about-services-bar {
    width: 86Px;
    height: 1Px;
    margin-bottom: 10Px;
    background: #fff;
  }
  .about-services-case {
    font-size: 14Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 26Px;
  }
  // .question-li {
  //   width: 1180Px;
  // }
  .question-row {
    position: relative;
    width: 1044Px;
    padding: 12Px 0 0 60Px;
    margin: 0 auto 30Px;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 275Px;
    }
    .question-index {
      position: absolute;
      left: 18Px;
      top: 26Px;
      font-size: 22Px;
      font-weight: 500;
      line-height: 26Px;
      color: rgba(110, 89, 26, 1);
    }
    .question {
      position: relative;
      z-index: 2;
      width: 935Px;
      padding: 20Px 18Px;
      border-radius: 12px;
      background: rgba(250, 245, 239, 1);
    }
    .question-title {
      font-size: 16Px;
      font-weight: 700;
      line-height: 16Px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 2Px;
    }
    .question-content {
      font-size: 14Px;
      font-weight: 400;
      line-height: 22Px;
      color: rgba(102, 102, 102, 1);
    }
  }
  @include h5() {
    .header {
    position: relative;
    padding-top: 88px;
    height: 280px;
    img {
      height: 280px;
      position: absolute;
      left: 0;
      // top: 0;
      z-index: -1;
    }
    .header-content {
      margin: 52px 24px 0;
    }
    .title {
      font-size: 32px !important;
      font-weight: 700;
      line-height: 32px;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 24px;
    }
    .sub-title {
      font-size: 14px !important;
      font-weight: 400;
      line-height: 16px;
      color: #fff;
      margin-bottom: 36px;
    }
    .sub-tips {
      font-size: 14px !important;
      font-weight: 400;
      line-height: 14px;
      color: #fff;
      margin-bottom: 30px;
    }
    .tag-list {
      display: flex;
      .tag-li {
        position: relative;
        font-size: 14px !important;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 14px;
        color: rgba(255, 255, 255, 1);
        padding: 8px 36px 16px 28px;
        border-radius: 4px;
        background: rgba(176, 152, 80, 1);
        backdrop-filter: blur(4px);
        margin-right: 30px;
      }
      .tag-bg {
        position: absolute;
        top: -6px;
        left: -6px;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow:inset 0px -1px 3px  rgba(255, 255, 255, 0.5);
      }
    }
  }
  .tab {
    background: rgba(242, 242, 242, 1);
    overflow-x: auto;
    .tab-list {
      width: 100%;
      display: flex;
      align-items: center;
      height: 60px;
      margin: 0 auto;
      .tab-li {
        display: flex;
        align-items: center;
        height: 60px;
        cursor: pointer;
        &:last-child .li-name{
          border: none;
        }
      }
      .li-name {
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
        padding: 0 16px;
        border-right: 1px solid rgba(151, 151, 151, 1);
      }
      .actived-tab {
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
        .li-name {
          color: rgba(170, 147, 77, 1);
          border: none;
        }
        img {
          width: 38px;
        }
      }
      .top-bar {
        height: 3px;
      }
      .second-tab{
        .li-name {
          border: none;
        }
      }
    }
  }
  .tab-fixed {
    top: 88px;
  }
  .banner {
    padding-top: 88px;
    img {
      position: relative;
      height: 280px;
      overflow: hidden;
    }
  }
  .banner-h5 {
    display: block;
  }
  .banner-pc {
    display: none;
  }
  .advantages {
    margin-top: 60px;
  }
  .advantages-li {
    margin-top: 58px;
  }
  .common-title {
    font-size: 32px;
    line-height: 42px;
  }
  .common-tips {
    margin-top: 8px;
    line-height: 22px;
  }
  .advantages-li,.processing-li,.processing-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .processing-title {
    text-align: center;
  }
  .processing-tips {
    font-size: 24px;
    line-height: 36px;
    width: unset;
  }
  .advantages-pc {
    display: none;
  }
  .advantages-h5 {
    display: block;
    padding: 0 24px;
    margin: 0;
    img {
      width: 703px;
    }
  }
  .advantages-left {
    height: unset;
  }
  .advantages-right {
    width: calc(100% - 48px);
    padding: 30px 24px 60px;
    font-size: 24px;
    line-height: 36px;
    div:first-child {
      font-size: 30px;
      text-indent: 1.6em;
    }
  }
  .processing {
    margin-top: 0;
  }
  .processing{
    padding-top: 60px;
  }
  .processing-icon {
    width: 78px;
    height: 78px;
    padding-bottom: 24px;
  }
  .processing-title {
    padding-bottom: 24px;
  }
  .processing-tips {
    padding-bottom: 60px;
  }
  .processing-con {
    padding: 72px 0 0px;
  }
  .processing-li {
    margin-top: 37px;
  }
  .processing-tips {
    padding-top: 0px;
  }
  .processing-title {
    font-size: 28px;
    line-height: 37px;
  }
  .processing-intr {
    padding: 0 24px; 
    text-align: center;
  }
  .services-pc {
    display: none;
  }
  .services-h5 {
    display: block;
  }
  .swiper-h5 {
    display: block;
    width: calc(100% - 224px);
    padding: 0 112px 0 112px;
  }
  .Contact {
    margin-top: 60px;
    padding: 36px 0 60px;
  }
  .Contact-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 20px;
    margin-top: 37px;
    .Contact-li {
      text-align: center;
    }
    .Contact-li:first-child {
      width: 100%;
      text-align: left;
    }
    .Contact-li:nth-child(2) {
      width: 199px;
    }
    .Contact-li:nth-child(3) {
      .Contact-title{
        padding-left: 14px;
      }
      width: 218px;
      .Contact-tips {
        width: 258px;
        margin-left: -18px;
      }
    }
    .Contact-li:last-child {
      .Contact-title{
        padding-left: 20px;
      }
      width: 268px;
      .Contact-tips {
        width: 288px;
      }
    }
    .Contact-tips {
      font-size: 20px;
      transform: scale(0.8);
    }
  }
  .Contact-way {
    display: flex;
    padding: 0;
  }
  .Contact-phone {
    display: flex;
    font-size: 24px;
    line-height: 29px;
    margin: 35px 0 92px 0;
    img {
      width: 30px;
      height: 30px;
      padding-right: 10px ;
    }
    .Contact-num {
      font-size: 24px;
      line-height: 29px;
    }
    span:last-child {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .Contact-phone:first-child {
    padding-right: 20px;
  }
  .Contact-content {
    margin-top: 13px;
    margin-right: 0;
    .Contact-img {
      width: 195px;
      height: 194px;
    }
  }
  .Contact-title {
    text-align: left;
    font-size: 24px;
    line-height: 31px;
  }
  .Contact-tips {
    font-size: 20px;
    line-height: 26px;
    margin-top: 15px;
  }
  .question-row {
    position: relative;
    padding: 12px 0 0 84px;
    margin: 0 auto 30px;
    img {
      position: absolute;
      left: 24px;
      top: 0;
      width: 275px;
    }
    .question-index {
      position: absolute;
      left: 42px;
      top: 26px;
      font-size: 22px;
      font-weight: 500;
      line-height: 26px;
      color: rgba(110, 89, 26, 1);
    }
    .question {
      position: relative;
      z-index: 2;
      width: calc(100vw - 144px);
      padding: 20px 18px;
      border-radius: 12px;
      background: rgba(250, 245, 239, 1);
    }
    .question-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 16px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 2px;
    }
    .question-content {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .content {
    width: 100%;
    margin: 0 24px;
    .content-text {
      width: calc(100% - 48px);
      font-size: 18px;
      font-weight: 400;
      line-height: 40px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .cover-li {
    .cover-tips {
      font-size: 18px;
      line-height: 40px;
    }
    .cover-intr {
      width: calc(100% - 48px);
      padding: 0 24px;
      .right-coverImg {
        width: 100%;
      }
    }
    .left-coverImg{
      width: calc(100% - 48px);
      padding: 0 24px;
    }
  }
}
}
@include h5 {
  .warp {
    padding-top: 80px;
  }
}
</style>
